import React, { useEffect } from 'react'
import { useConcursoTikTok } from '../../../../hooks/useConcursoTikTok2025';

const IntroductionComponent = () => {

    const { introduccion, getIntroduccion } = useConcursoTikTok();

    useEffect(() => {
        getIntroduccion(2026)
    }, [])

    return (
        <div className="container-fluid section-home mt-0 mt-md-5" id="introduccion">
            <div className="row justify-content-center">
                <div className="col-12 anchor-section">
                </div>
                <div className="col-md-8 inner-sections">
                    <div className="title-tiktok-info">
                        <h2>Introducción</h2>
                    </div>
                    <div className="container-inner-info p-4">
                        <div className="paragraph_content" dangerouslySetInnerHTML={{__html: `${introduccion?.texto}` }}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IntroductionComponent
